import React, { useEffect, useState } from "react";
import ModelViewer from "../../react-components/3d-viewer";
import "./style.scss";
import { canvas, scene } from "../../webgl/demo/";
import { GlobalHotKeys } from "react-hotkeys";

const CarModel = ({ fields }) => {
  const { car3d } = fields;
  let { colors = [] } = car3d?.fields;
  const { defaultEngine, defaultColorIndex, defaultTowbar, defaultSnow } = car3d?.fields;
  const sticky = fields?.sticky?.value;
  const useHotKeys = fields?.useHotKeys?.value;
  const loanBannerHeight = "";

  colors = colors.map(color => ({
    key: color.fields.key.value,
    color: Number(color.fields.color.value),
    metalness: Number(color.fields.metalness.value)
  }));

  const sceneData = {
    colors: {},
    defaults: {
      color: colors[parseInt(defaultColorIndex?.value)] || colors[0],
      engine: defaultEngine?.value || "engine-phev",
      towbar: defaultTowbar?.value,
      snow: defaultSnow.value
    }
  };

  colors.forEach(color => {
    sceneData.colors[color.key] = color;
  });

  const [currentColor, setCurrentColor] = useState(defaultColorIndex?.value || 0);
  const [currentEngine, setCurrentEngine] = useState(sceneData.defaults.engine === "engine-phev");
  const [currentSnow, setCurrentSnow] = useState(sceneData.defaults.snow);

  const keyMap = {
    COLOR: car3d?.fields?.color?.value,
    ENGINE: car3d?.fields?.engine?.value,
    TYRES: car3d?.fields?.tires?.value
  };

  const keyHandlers = {
    COLOR: () => {
      useHotKeys && setCurrentColor(prev => (parseInt(prev) + 1) % colors.length);
    },
    ENGINE: () => useHotKeys && setCurrentEngine(prev => !prev),
    TYRES: () => useHotKeys && setCurrentSnow(prev => !prev)
  };

  useEffect(() => {
    scene.callbacks.setCarColor(canvas, colors[currentColor]);
  }, [currentColor]);

  useEffect(() => {
    scene.callbacks.setPHEV(canvas, currentEngine);
  }, [currentEngine]);

  useEffect(() => {
    scene.callbacks.displaySnow(canvas, currentSnow);
  }, [currentSnow]);

  return (
    <div className={"car-model " + (sticky ? "sticky" : "")}>
      <GlobalHotKeys keyMap={keyMap} handlers={keyHandlers} className="hot-keys-container">
        <ModelViewer fields={fields} canvas={canvas} scene={scene} data={sceneData} loanBannerHeight={loanBannerHeight}>
          <div className="viewer-bottom-gradient" />
        </ModelViewer>
      </GlobalHotKeys>
    </div>
  );
};

export default CarModel;
